// extracted by mini-css-extract-plugin
export default {"scoreField":"InputField_scoreField__G8lNl","editToggle":"InputField_editToggle__IjwEh"};